module.exports = __webpack_public_path__ + "img/success.93d900b0.png";